<template>
  <div class="report-unordered">
    <mainmenu selected="report-orders"></mainmenu>
    <div class="container-fluid report-unordered-shell">
      <div class="report-unordered-header">
        <div>
          <h1>{{$t('report_unordered_products.page_title')}}</h1>
          <div class="report-unordered-summary">{{$t('report_unordered_products.subtitle')}}</div>
        </div>
        <a :href="$http.options.root + 'report_unordered_articles/export_excel'" target="_blank" class="el-button el-button--success report-export-button">
          <i class="el-icon-download"></i>
          {{$t('report_unordered_products.export_to_excel')}}
        </a>
      </div>

      <div class="report-summary-grid">
        <div v-for="tile in SummaryTiles" :key="tile.key" :class="['summary-tile', tile.theme]">
          <strong>{{tile.value}}</strong>
          <span>{{tile.label}}</span>
        </div>
      </div>

      <div class="report-filter-card">
        <div class="report-filter-grid">
          <div class="filter-label">{{$t('report_unordered_products.filters')}}</div>
          <el-input
            class="search-input"
            v-model="Filters.Search"
            clearable
            prefix-icon="el-icon-search"
            :placeholder="$t('report_unordered_products.search_placeholder')">
          </el-input>
          <div class="switch-filter">
            <el-switch v-model="Filters.OnlyNeverOrdered"></el-switch>
            <span>{{$t('report_unordered_products.only_never_ordered')}}</span>
          </div>
          <div class="filter-actions">
            <el-button icon="el-icon-refresh" @click="refresh_info">{{$t('report_unordered_products.refresh')}}</el-button>
            <el-button icon="el-icon-close" @click="resetFilters">{{$t('report_unordered_products.reset')}}</el-button>
          </div>
        </div>
      </div>

      <div class="report-unordered-card">
        <div class="report-card-title">
          <div>
            <span>{{$t('report_unordered_products.stock_list')}}</span>
            <small>{{$t('report_unordered_products.sorted_by_laundry')}}</small>
          </div>
          <span class="total-pill">{{$t('report_unordered_products.total')}} {{FilteredResults.length}}</span>
        </div>

        <el-table
          class="report-unordered-table"
          :data="FilteredResults"
          :height="tableHeight"
          stripe
          v-loading="tableLoadingVisible"
          :empty-text="$t('report_unordered_products.empty_results')">
          <el-table-column :label="$t('report_unordered_products.factory_code')" width="115">
            <template slot-scope="scope">
              <span class="laundry-code">{{scope.row.FactoryCode}}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('report_unordered_products.article_info')" min-width="380">
            <template slot-scope="scope">
              <div class="article-main"><strong>{{scope.row.ArticleNumber}}</strong> - {{scope.row.ProductName}}</div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('report_unordered_products.first_upload_date')" width="170">
            <template slot-scope="scope">{{formatDate(scope.row.FirstUploadDate)}}</template>
          </el-table-column>

          <el-table-column :label="$t('report_unordered_products.current_quantity')" width="145" align="right">
            <template slot-scope="scope">{{formatNumber(scope.row.CurrentQuantity)}}</template>
          </el-table-column>

          <el-table-column :label="$t('report_unordered_products.ordered_quantity')" width="145" align="right">
            <template slot-scope="scope">{{formatNumber(scope.row.OrderedQuantity)}}</template>
          </el-table-column>

          <el-table-column :label="$t('report_unordered_products.ordering_signal')" width="165">
            <template slot-scope="scope">
              <span :class="['activity-pill', orderedQuantity(scope.row) > 0 ? 'activity-ordered' : 'activity-never']">
                {{orderedQuantity(scope.row) > 0 ? $t('report_unordered_products.has_orders') : $t('report_unordered_products.never_ordered')}}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import MainMenu from "./../../widgets/MainMenu";
import settings from "./../../backend/LocalSettings";

function buildDefaultFilters() {
  return {
    Search: "",
    OnlyNeverOrdered: false
  };
}

export default {
  name: "report-unordered-articles",
  components: {
    "mainmenu": MainMenu
  },
  data() {
    return {
      tableLoadingVisible: false,
      Results: [],
      Filters: buildDefaultFilters(),
      tableHeight: 520
    };
  },
  computed: {
    FilteredResults: function() {
      var search = (this.Filters.Search || "").toLowerCase().trim();
      var onlyNeverOrdered = this.Filters.OnlyNeverOrdered;

      return this.Results.filter(function(row) {
        if(onlyNeverOrdered && this.orderedQuantity(row) > 0) return false;
        if(!search) return true;

        var haystack = [
          row.FactoryCode,
          row.ArticleNumber,
          row.ProductName
        ].join(" ").toLowerCase();

        return haystack.indexOf(search) >= 0;
      }, this);
    },
    Summary: function() {
      var factories = {};
      var openQuantity = 0;
      var neverOrdered = 0;

      this.FilteredResults.forEach(function(row) {
        if(row.FactoryCode) factories[row.FactoryCode] = true;
        openQuantity += Number(row.CurrentQuantity) || 0;
        if(this.orderedQuantity(row) <= 0) neverOrdered++;
      }, this);

      return {
        rows: this.FilteredResults.length,
        laundries: Object.keys(factories).length,
        openQuantity: openQuantity,
        neverOrdered: neverOrdered
      };
    },
    SummaryTiles: function() {
      return [
        { key: "rows", label: this.$t('report_unordered_products.rows'), value: this.formatNumber(this.Summary.rows), theme: "" },
        { key: "laundries", label: this.$t('report_unordered_products.laundries'), value: this.formatNumber(this.Summary.laundries), theme: "" },
        { key: "open", label: this.$t('report_unordered_products.open_quantity'), value: this.formatNumber(this.Summary.openQuantity), theme: "" },
        { key: "never", label: this.$t('report_unordered_products.never_ordered'), value: this.formatNumber(this.Summary.neverOrdered), theme: "attention" }
      ];
    }
  },
  methods: {
    updateTableHeight: function() {
      var availableHeight = window.innerHeight - 430;
      this.tableHeight = Math.max(360, Math.min(availableHeight, 650));
    },
    orderedQuantity: function(row) {
      return Number(row && row.OrderedQuantity) || 0;
    },
    formatNumber: function(value) {
      var numberValue = Number(value) || 0;
      return numberValue.toLocaleString();
    },
    formatDate: function(value) {
      if(!value || value === "0000-00-00 00:00:00") return "-";
      var parts = String(value).split(/[- :]/);
      if(parts.length < 5) return value;
      var dateValue = new Date(Date.UTC(
        Number(parts[0]),
        Number(parts[1]) - 1,
        Number(parts[2]),
        Number(parts[3] || 0),
        Number(parts[4] || 0),
        Number(parts[5] || 0)
      ));
      if(isNaN(dateValue.getTime())) return value;
      var pad = function(part) { return String(part).padStart(2, "0"); };
      return pad(dateValue.getDate()) + "." + pad(dateValue.getMonth() + 1) + "." + dateValue.getFullYear() + " " + pad(dateValue.getHours()) + ":" + pad(dateValue.getMinutes());
    },
    resetFilters: function() {
      this.Filters = buildDefaultFilters();
    },
    refresh_info: function() {
      this.tableLoadingVisible = true;
      this.$http
        .post('report_unordered_articles/refresh_info', {})
        .then(function(response) {
          this.tableLoadingVisible = false;
          if(settings.verify_response(response, this.$rights)) {
            this.Results = response.body.Results || [];
          } else {
            this.$router.push("/");
          }
        })
        .catch(function() {
          this.tableLoadingVisible = false;
          this.$message.error(this.$t('report_unordered_products.load_failed'));
        });
    }
  },
  mounted: function() {
    this.updateTableHeight();
    window.addEventListener("resize", this.updateTableHeight);
    this.refresh_info();
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.updateTableHeight);
  }
};
</script>

<style lang="less" scoped>
.report-unordered-shell {
  padding: 14px 10px 28px;
}

.report-unordered-header,
.report-filter-card,
.report-unordered-card,
.summary-tile {
  border: 1px solid rgba(26, 88, 111, 0.12);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 12px 26px rgba(25, 80, 99, 0.13);
}

.report-unordered-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 12px;
  padding: 18px;

  h1 {
    margin: 0;
    color: #152b38;
    font-size: 31px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 36px;
  }
}

.report-unordered-summary {
  margin-top: 3px;
  color: rgba(21, 43, 56, 0.72);
  font-size: 13px;
  font-weight: 600;
}

.report-summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 12px;
}

.summary-tile {
  min-height: 76px;
  padding: 14px 16px;
  border-left: 3px solid #2499ad;

  strong {
    display: block;
    color: #183342;
    font-size: 26px;
    font-weight: 800;
    line-height: 29px;
  }

  span {
    display: block;
    margin-top: 6px;
    color: #61737f;
    font-size: 12px;
    font-weight: 800;
    text-transform: uppercase;
  }
}

.summary-tile.attention {
  border-left-color: #f1a742;
  background: #fffaf2;

  strong {
    color: #9a5a13;
  }
}

.report-filter-card {
  margin-bottom: 12px;
  padding: 12px 18px;
}

.report-filter-grid {
  display: grid;
  grid-template-columns: 78px minmax(260px, 1fr) 230px auto;
  align-items: center;
  gap: 12px;
}

.filter-label {
  color: #334b59;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.switch-filter {
  display: flex;
  align-items: center;
  gap: 9px;
  color: #344b59;
  font-size: 13px;
  font-weight: 700;
}

.filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.report-unordered-card {
  overflow: hidden;
}

.report-card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 13px 18px;
  border-bottom: 1px solid #e6edf2;
  background: #fbfdfe;
  color: #223947;
  font-size: 15px;
  font-weight: 800;

  small {
    display: block;
    margin-top: 2px;
    color: #6b7c87;
    font-size: 12px;
    font-weight: 700;
  }
}

.total-pill {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0 10px;
  border-radius: 4px;
  background: #eef6f9;
  color: #2b6275;
  font-size: 12px;
  font-weight: 800;
}

.report-unordered-table /deep/ th {
  padding: 10px 0;
  background: #f4f8fa;
  color: #526875;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
}

.report-unordered-table /deep/ td {
  padding: 7px 0;
  border-bottom-color: #e7edf2;
  color: #405461;
}

.laundry-code {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 8px;
  border-radius: 4px;
  background: #eef8fa;
  color: #246174;
  font-size: 12px;
  font-weight: 800;
}

.article-main {
  color: #314754;
  line-height: 19px;
}

.activity-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  padding: 0 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 800;
}

.activity-never {
  border: 1px solid #ffd1c9;
  background: #fff5f3;
  color: #d95b4f;
}

.activity-ordered {
  border: 1px solid #cde8c5;
  background: #f1faee;
  color: #4f9f35;
}

@media (max-width: 1020px) {
  .report-summary-grid,
  .report-filter-grid {
    grid-template-columns: 1fr 1fr;
  }

  .filter-label {
    grid-column: 1 / -1;
  }
}

@media (max-width: 760px) {
  .report-unordered-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .report-summary-grid,
  .report-filter-grid {
    grid-template-columns: 1fr;
  }

  .filter-actions {
    justify-content: flex-start;
  }
}
</style>
